import React from "react";
import { StyledTagline } from "./StyledTagline";

function Tagline() {
  return (
    <StyledTagline>
      <div className="wrapper">
        <h1>Your Pizza, your way !</h1>
        <h2>Unless you like pineapple, then we've to talk.</h2>
      </div>
    </StyledTagline>
  );
}

export default Tagline;
